/**
 * Validates that a string is a valid postal code.
 */
export const isValidPostalCode = (postalCode: string): boolean => {
  const postalCodeRegex = new RegExp(
    "^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$",
    "i",
  );
  return postalCodeRegex.test(postalCode);
};

export const normalizePostalCode = (postalCode: string): string => {
  return postalCode.trim().replace(" ", "").toUpperCase();
};
